module.exports = __webpack_public_path__ + "static/media/baseline-menu-24px.a4cb5c87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/baseline-menu-24px.svg
// module id = 146
// module chunks = 43